import { useEffect} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Table from 'components/__new/common/Table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getAllEmployees } from 'store/entities/employees/action';
import Spinner from '../common/Spinner';
import CurrencyFormat from 'utils/currencyFormat';
import Maybe from '../common/Maybe';

const CompactEmployees = ({selected, setSelected, showAll, limit, setLimit}) => {
    const dispatch = useDispatch()
    const { allEmployees, employeesLoading } = useSelector(state => state.entities.employees)

    const unassignedStaff = allEmployees?.docs?.filter((item) => {
        return item.disabled === false && (!item?.pay_group_id || item?.pay_group_id === null || item?.pay_group_id?.length < 1)
    })
    const emptyData = !employeesLoading && unassignedStaff?.length === 0;
    const allEmployeeIDs = unassignedStaff?.map(item => item._id)

    const toggleSingleGroup = (id) => {
        const alreadyExists = selected?.indexOf(id) > -1
        if (alreadyExists) {
            const filtered = selected?.filter(item => item !== id)
            setSelected(filtered)
        } else {
            setSelected([...selected, id])
        }
    }

    const toggleEntireList = () => {
        if (selected.length !== allEmployeeIDs?.length) {
            setSelected(allEmployeeIDs)
        } else {
            setSelected([])
        }
    }

    useEffect(() => {
        dispatch(getAllEmployees({page: 1, limit}))
        // eslint-disable-next-line
    }, [limit])


    return (
        <div>
            <Maybe condition={employeesLoading}>
                <Spinner message="Fetching Employees" />
            </Maybe>
            
            <Maybe condition={emptyData}>
                <div className="table-info">
                    <FontAwesomeIcon icon="unlink" />
                    <div className="font-semibold uppercase">
                        {allEmployees?.docs?.length < 1 ? "You haven't added any employees" : "All employees have already been assigned to pay groups"}
                    </div>
                </div>
            </Maybe>
            
            <Maybe condition={employeesLoading === false && unassignedStaff?.length > 0}>
                <div className="mt-6 bg-white p-5">
                    <Table>
                        <Table.Head>
                            <th>
                            <div className="flex items-center">
                            <div className="mr-6">
                                {!emptyData &&
                                    <input
                                        type="checkbox"
                                        onChange={() => toggleEntireList()}
                                        checked={selected.length === allEmployeeIDs?.length}
                                        className="w-5 h-5 mr-3.5 form-checkbox float-left"
                                    />
                                }
                            </div>
                            <p className="mb-0">Name of Employee</p>
                            </div>
                            </th>
                            <th>Employee ID</th>
                            <th>Gross Salary (Yearly)</th>
                        </Table.Head>
                        <Table.Body className='border'>
                            {unassignedStaff?.map((employee) =>
                                <tr key={employee._id}>
                                    <td>
                                    <div className='flex items-center'>
                                        <div className="mr-6">
                                        <input onChange={() => toggleSingleGroup(employee._id)}
                                            checked={selected?.includes(employee._id)}
                                            type="checkbox" className="w-5 h-5 mr-2 form-checkbox float-left" />
                                        </div>
                                        <p className="mb-0 capitalize">{employee.firstName + " " + employee.lastName}</p>
                                        </div>
                                    </td>
                                    <td>{employee.employeeId || "N/A"}</td>
                                    <td>{employee.grossAnnualPay ? CurrencyFormat(employee.grossAnnualPay) : "N/A"}</td>
                                </tr>
                            )}
                        </Table.Body>
                    </Table>
                    <div className="mt-4 w-full ml-14">
                        <button disabled={showAll} onClick={() => setLimit((prev) => prev + 10)} className="btn btn-sm btn-transparent-primary">
                            Add new rows
                        </button>
                    </div>
                </div>
            </Maybe>            
        </div>
    )
}

export default CompactEmployees